import React, { useEffect, useState } from 'react';
import Footer from '../Components/footer';
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Images/Home/boat.png";
import Vid from "../Images/Contact/sunset.webm";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { Input } from '@chakra-ui/react';

export default function Contact(props) {

    const [User, SetUser] = useState('');
    const navigate = useNavigate();
    const [dateTime, setDateTime] = useState('');
    const [route, setRoute] = useState('');
    const [boat, setBoat] = useState('');

    useEffect(() => {
        onAuthStateChanged(props.auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                SetUser(user);
                const uid = user.uid;
                // ...
                console.log("uid", uid)
            } else {
                // User is signed out
                // ...
                navigate("/login");
                console.log("user is logged out")
            }
        });
    }, [])

    function signout() {
        signOut(props.auth).then(() => {
            window.location.reload(false);
            // Sign-out successful.
        }).catch((error) => {
            // An error happened.
        });
    }

    async function onSubmitChange(e) {
        e.preventDefault()
        const date = dateTime.split("T")
        console.log(date[0])
        await updateDoc(doc(props.db, "users", User.uid), {
            bookings: arrayUnion({ boat: boat, route: route, date: date[0] }),
        }).then((e)=> window.location.reload(false))
    }

    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-dark nav-bg fixed-top">
                <div className="container-fluid">
                    <Link to="/" className="navbar-brand"><img src={Logo} alt="Logo" width="30" height="30" /></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 navbar-nav-scroll">
                            <li className="nav-item">
                                <Link to="/" className="nav-link" aria-current="page">Home</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Boats
                                </a>
                                <ul className="dropdown-menu">
                                    <li><Link to="/cechoii" className="dropdown-item">C-ECHO II</Link></li>
                                    <li><Link to="/nimar" className="dropdown-item">Nimar</Link></li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <Link to="/routes" className="nav-link">Routes</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/news" className="nav-link">News</Link>
                                </li>
                            {User !== '' ? <li className="nav-item">
                                <Link to="/contact" className="nav-link">Book a boat</Link>
                            </li> : null}
                        </ul>
                        <ul className="navbar-nav navbar-nav-scroll">
                            {User !== '' ? <li className="nav-item">
                                <Link to="/bookings" className="nav-link">Bookings</Link>
                            </li> : null}
                            <li className="nav-item">
                                {User === '' ? <Link to="/login" className="nav-link">Login</Link> : null}
                            </li>
                            <li className="nav-item">
                                {User === '' ? <Link to="/signup" className="nav-link">Register</Link> : null}
                            </li>
                            <li>
                                {User !== '' ? <Link to="/" className="nav-link" onClick={signout}>Logout</Link> : null}
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <section>
                <div className="video-wrapper">
                    <video playsInline autoPlay muted loop poster="Images2/6.jpg">
                        <source src={Vid} type="video/webm" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </section>
            <section id="Booking">
                <div className="form-body">
                    <div className="row">
                        <div className="form-holder">
                            <div className="form-content">
                                <div className="form-items">
                                    <h3>Book Now</h3>
                                    <p>Fill in the data below.</p>
                                    <form className="requires-validation" noValidate>
                                        <div className="col-md-12">
                                            <select className="form-select mt-3" required onChange={(e) => setBoat(e.target.value)} value={boat}>
                                                <option value>Boat</option>
                                                <option value="Nimar">Nimar</option>
                                                <option value="C-echo II">C-echo II</option>
                                            </select>
                                            <div className="valid-feedback">You selected a Boat!</div>
                                            <div className="invalid-feedback">Please select a Boat!</div>
                                        </div>
                                        <div className="col-md-12">
                                            <select className="form-select mt-3" required onChange={(e) => setRoute(e.target.value)} value={route}>
                                                <option>Route</option>
                                                <option value="NORTH CLASSIC" >NORTH CLASSIC</option>
                                                <option value="NORTH + BROTHERS" >NORTH + BROTHERS</option>
                                                <option value="WRECKS" >WRECKS</option>
                                                <option value="GREAT SOUTH" >GREAT SOUTH</option>
                                            </select>
                                            <div className="valid-feedback">You selected a position!</div>
                                            <div className="invalid-feedback">Please select a position!</div>
                                        </div>
                                        <Input
                                            placeholder="Select Date and Time"
                                            size="md"
                                            type="datetime-local"
                                            bgColor={"#fff"}
                                            className=' mt-3'
                                            value={dateTime}
                                            onChange={(e) => setDateTime(e.target.value)}
                                        />
                                        <div className="col-md-12 mt-3">
                                            <label className="mb-3" htmlFor="gender">Gender: </label>
                                            <input type="radio" className="btn-check" name="gender" id="male" autoComplete="off" required />
                                            <label className="mx-2 btn btn-sm btn-outline-secondary" htmlFor="male">Male</label>
                                            <input type="radio" className="btn-check" name="gender" id="female" autoComplete="off" required />
                                            <label className="btn btn-sm btn-outline-secondary" htmlFor="female">Female</label>
                                            <div className="valid-feedback mv-up">You selected a gender!</div>
                                            <div className="invalid-feedback mv-up">Please select a gender!</div>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" defaultValue id="invalidCheck" required />
                                            <label className="form-check-label">I confirm that all data are correct</label>
                                            <div className="invalid-feedback">Please confirm that the entered data are all correct!</div>
                                        </div>
                                        <div className="form-button mt-3">
                                            <button id="submit" className="btn btn-primary" onClick={onSubmitChange}>Register</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}